import React from 'react';
export function SocialProofBar() {
  return <section className="w-full bg-[#001a0d] py-12 px-4" data-id="element-278">
      <div className="max-w-5xl mx-auto" data-id="element-279">
        {/* Stats */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 mb-12 text-center" data-id="element-280">
          <div data-id="element-281">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-282">
              +500
            </div>
            <div className="text-[#00C853] text-sm font-semibold mt-1" data-id="element-283">
              docentes confían
            </div>
          </div>
          <div data-id="element-284">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-285">6</div>
            <div className="text-[#00C853] text-sm font-semibold mt-1" data-id="element-286">
              Tomos listos
            </div>
          </div>
          <div data-id="element-287">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-288">6</div>
            <div className="text-[#00C853] text-sm font-semibold mt-1" data-id="element-289">
              Bonos incluidos
            </div>
          </div>
          <div data-id="element-290">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-291">
              4.9/5
            </div>
            <div className="text-[#00C853] text-sm font-semibold mt-1" data-id="element-292">
              calificación ⭐
            </div>
          </div>
        </div>

        {/* Micro testimonials */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-293">
          <div className="flex items-start gap-3 bg-black/40 border border-[#00C853]/20 rounded-xl p-4" data-id="element-294">
            <div className="w-10 h-10 rounded-full bg-[#00C853]/20 flex items-center justify-center text-[#00C853] font-black text-sm flex-shrink-0" data-id="element-295">
              MG
            </div>
            <div data-id="element-296">
              <div className="text-[#00C853] text-xs mb-1" data-id="element-297">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-298">
                "Organicé todo el año en una tarde. El solucionario me ahorra
                horas cada semana."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-299">
                — Mariela G., Córdoba
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-black/40 border border-[#00C853]/20 rounded-xl p-4" data-id="element-300">
            <div className="w-10 h-10 rounded-full bg-[#00C853]/20 flex items-center justify-center text-[#00C853] font-black text-sm flex-shrink-0" data-id="element-301">
              LP
            </div>
            <div data-id="element-302">
              <div className="text-[#00C853] text-xs mb-1" data-id="element-303">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-304">
                "El Congiuntivo por fin se entiende. Los tomos de gramática
                visual son el hit de la clase."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-305">
                — Laura P., Rosario · Instituto de Idiomas
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-black/40 border border-[#00C853]/20 rounded-xl p-4" data-id="element-306">
            <div className="w-10 h-10 rounded-full bg-[#00C853]/20 flex items-center justify-center text-[#00C853] font-black text-sm flex-shrink-0" data-id="element-307">
              RM
            </div>
            <div data-id="element-308">
              <div className="text-[#00C853] text-xs mb-1" data-id="element-309">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-310">
                "Mis clases de B2 por fin enganchan. El Tomo C1/C2 vale cada
                peso."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-311">
                — Roberto M., Buenos Aires
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}